// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-user.social article{width: 450px;}
.main-user.social .informacion-social{ width: calc(100% - 550px);}
/* -----------------------------------------------------------------------------
// FORMULARIO SOLICITAR CITA
// ----------------------------------------------------------------------------- */
.social .cita-social{
    height: fit-content;
    border-radius: 20px;
}

.social .cita-social .modal-header{ 
  padding: 20px 20px 16px 10px ; 
  align-items: flex-start;
  background-color: #3C4A99;
}

.cita-social form{ padding: 25px; background-color: white;}
.cita-social .campo{ border-bottom: 1px solid #3C4A99; }
.cita-social .boton:hover{ border: 2px solid white; }
.cita-social .close-button{background-color: #3C4A99;}
.cita-social .close-button:hover{color: #3C4A99; background-color: white;}


/* -----------------------------------------------------------------------------
// INFORMACIÓN SERVICIOS SOCIALES
// ----------------------------------------------------------------------------- */
.social .informacion-social .boton-modal{ padding: 5px 20px; }

.social .informacion-social{ 
    margin-top: 0px; 
}


/* --  admin -- */
.social .info-comple{ width: 550px; }

.social .info-comple a{ 
  display: block;
  text-align: center;
}

/* -----------------------------------------------------------------------------
// DESPLEGABLE
// ----------------------------------------------------------------------------- */
.social .desplegable{
  border-bottom: 2px solid #007932;
  padding: 17.5px 15px 16px 15px;
}

.social .desplegable h2{ font-size: 18px; }

.social .contenido ul{ 
  list-style: none;
  padding-left: 10px;
  margin-top: 10px;
}

.social .contenido{ margin-top: 10px; }

.social .contenido li{
   margin: 2.5px 0px; 
   border-bottom: 0px; 
}

.social .contenido a{ color: black; }
.social .contenido a:hover{ text-decoration: underline; }



/* -----------------------------------------------------------------------------
// RECURSOS
// ----------------------------------------------------------------------------- */
main.social .noticias, 
.recomendado.social .noticias{
  flex-wrap: wrap;
  margin-top: 20px;
  gap: 20px 2.6%;
  align-items: stretch;
}


main.social .noticias .noticia, 
.recomendado.social .noticias .noticia{
  border: 1px solid #3C4A99;
  border-left: 12px solid #3C4A99;
  border-radius: 20px;
  padding: 12px 25px;
  width: 31%;
}

main.social.tecnicos .noticias .noticia, 
.recomendado.social .noticias .noticia{
  width: 23%;
}

main.social .noticias .etiqueta, 
.recomendado.social .noticias .etiqueta{
  text-align: end;
  font-size: 14px;
  font-weight: bold;
}

.recurso .etiqueta{
  text-align: end;
  font-size: 14px;
  font-weight: bold;
}


/* -----------------------------------------------------------------------------
// LISTADO PROGRAMAS
// ----------------------------------------------------------------------------- */
.programas-sociales .acciones svg:hover{color: black;}

.programas-sociales .historico-seguimiento .modal-header{ 
  padding: 18px 15px; 
  background-color: #3C4A99; 
}

.programas-sociales .historico-seguimiento .modal-body{ padding: 20px 25px 25px 25px; }
.programas-sociales .historico-seguimiento input{ border-bottom: 1px solid #3C4A99 }
.programas-sociales .historico-seguimiento input::placeholder{ color: black; }
.programas-sociales .historico-seguimiento .boton{ padding: 5px 20px; }`, "",{"version":3,"sources":["webpack://./src/pages/user/css/Social.css"],"names":[],"mappings":"AAAA,0BAA0B,YAAY,CAAC;AACvC,uCAAuC,yBAAyB,CAAC;AACjE;;kFAEkF;AAClF;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,mBAAmB,aAAa,EAAE,uBAAuB,CAAC;AAC1D,qBAAqB,gCAAgC,EAAE;AACvD,2BAA2B,uBAAuB,EAAE;AACpD,2BAA2B,yBAAyB,CAAC;AACrD,iCAAiC,cAAc,EAAE,uBAAuB,CAAC;;;AAGzE;;kFAEkF;AAClF,0CAA0C,iBAAiB,EAAE;;AAE7D;IACI,eAAe;AACnB;;;AAGA,iBAAiB;AACjB,sBAAsB,YAAY,EAAE;;AAEpC;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;kFAEkF;AAClF;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA,yBAAyB,eAAe,EAAE;;AAE1C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB,gBAAgB,EAAE;;AAEtC;GACG,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA,sBAAsB,YAAY,EAAE;AACpC,4BAA4B,0BAA0B,EAAE;;;;AAIxD;;kFAEkF;AAClF;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;;AAGA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;;AAGA;;kFAEkF;AAClF,wCAAwC,YAAY,CAAC;;AAErD;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,wDAAwD,4BAA4B,EAAE;AACtF,kDAAkD,iCAAiC;AACnF,+DAA+D,YAAY,EAAE;AAC7E,mDAAmD,iBAAiB,EAAE","sourcesContent":[".main-user.social article{width: 450px;}\n.main-user.social .informacion-social{ width: calc(100% - 550px);}\n/* -----------------------------------------------------------------------------\n// FORMULARIO SOLICITAR CITA\n// ----------------------------------------------------------------------------- */\n.social .cita-social{\n    height: fit-content;\n    border-radius: 20px;\n}\n\n.social .cita-social .modal-header{ \n  padding: 20px 20px 16px 10px ; \n  align-items: flex-start;\n  background-color: #3C4A99;\n}\n\n.cita-social form{ padding: 25px; background-color: white;}\n.cita-social .campo{ border-bottom: 1px solid #3C4A99; }\n.cita-social .boton:hover{ border: 2px solid white; }\n.cita-social .close-button{background-color: #3C4A99;}\n.cita-social .close-button:hover{color: #3C4A99; background-color: white;}\n\n\n/* -----------------------------------------------------------------------------\n// INFORMACIÓN SERVICIOS SOCIALES\n// ----------------------------------------------------------------------------- */\n.social .informacion-social .boton-modal{ padding: 5px 20px; }\n\n.social .informacion-social{ \n    margin-top: 0px; \n}\n\n\n/* --  admin -- */\n.social .info-comple{ width: 550px; }\n\n.social .info-comple a{ \n  display: block;\n  text-align: center;\n}\n\n/* -----------------------------------------------------------------------------\n// DESPLEGABLE\n// ----------------------------------------------------------------------------- */\n.social .desplegable{\n  border-bottom: 2px solid #007932;\n  padding: 17.5px 15px 16px 15px;\n}\n\n.social .desplegable h2{ font-size: 18px; }\n\n.social .contenido ul{ \n  list-style: none;\n  padding-left: 10px;\n  margin-top: 10px;\n}\n\n.social .contenido{ margin-top: 10px; }\n\n.social .contenido li{\n   margin: 2.5px 0px; \n   border-bottom: 0px; \n}\n\n.social .contenido a{ color: black; }\n.social .contenido a:hover{ text-decoration: underline; }\n\n\n\n/* -----------------------------------------------------------------------------\n// RECURSOS\n// ----------------------------------------------------------------------------- */\nmain.social .noticias, \n.recomendado.social .noticias{\n  flex-wrap: wrap;\n  margin-top: 20px;\n  gap: 20px 2.6%;\n  align-items: stretch;\n}\n\n\nmain.social .noticias .noticia, \n.recomendado.social .noticias .noticia{\n  border: 1px solid #3C4A99;\n  border-left: 12px solid #3C4A99;\n  border-radius: 20px;\n  padding: 12px 25px;\n  width: 31%;\n}\n\nmain.social.tecnicos .noticias .noticia, \n.recomendado.social .noticias .noticia{\n  width: 23%;\n}\n\nmain.social .noticias .etiqueta, \n.recomendado.social .noticias .etiqueta{\n  text-align: end;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.recurso .etiqueta{\n  text-align: end;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n\n/* -----------------------------------------------------------------------------\n// LISTADO PROGRAMAS\n// ----------------------------------------------------------------------------- */\n.programas-sociales .acciones svg:hover{color: black;}\n\n.programas-sociales .historico-seguimiento .modal-header{ \n  padding: 18px 15px; \n  background-color: #3C4A99; \n}\n\n.programas-sociales .historico-seguimiento .modal-body{ padding: 20px 25px 25px 25px; }\n.programas-sociales .historico-seguimiento input{ border-bottom: 1px solid #3C4A99 }\n.programas-sociales .historico-seguimiento input::placeholder{ color: black; }\n.programas-sociales .historico-seguimiento .boton{ padding: 5px 20px; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
